import { FilterOption } from "../../components/genericFilters/filterRegistry";
import { Tab } from "../../components/ouletModal/OutletModalTypes";
import { DataConfig } from "../../services/mdmService/types";

export interface mdmMenuOption {
  id: string;
  icon: string;
  label: string;
}
export interface tranformerInfoObj {
  entityName: string,
  transformerId: string,
  // operationType?: string
  [key: string]: string | boolean
}
export interface mdmRegistryObj {
  id: string;
  name: string;
  entity: string;
  designation?:string,
  menuOption: mdmMenuOption[];
  "transformerInfo": tranformerInfoObj[];
  transformerId?: string;
  tableHeaders?:any;
  modalConfig?:Tab[];
  exportConfig?:any;
  globalFilters?: FilterOption[];
  fileType?: "excel" | "zip";
  searchEnabledColumnsConfig?:string[];
  userNameKey?:boolean; 
  disableEdit?:boolean 
  getDataConfig?:DataConfig
  useKafka?:boolean;
  chainingJobName?:string;
}
export const mdmRegistry: mdmRegistryObj[] = 
[
  {
    "id": "Division",
    "name": "Division",
    "entity": "Division",
    "menuOption": [
      {
        "id": "viewsAndEditDivision",
        "icon": "viewsAndEditIcon",
        "label": "View and Edit"
      }
    ],
    "transformerInfo": [{
      "entityName": "Division",
      "transformerId": "default_division"
  }]
  },
  {
    "id": "User",
    "name": "User",
    "entity": "User",
    "designation": "",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      },
      {
        "id": "viewsAndEdit",
        "icon": "viewsAndEditIcon",
        "label": "View and Edit"
      },
      {
        "id": "masterDownload",
        "icon": "masterDownloadIcon",
        "label": "Master Download"
      },
      {
        "id": "dataSupportDownload",
        "icon": "masterDownloadIcon",
        "label": "Data Validation Support"
      }
    ],
    "transformerInfo": [{
      "entityName": "User",
      "transformerId": "mdm_user"
    }]
  },
  {
    "id": "SupplierMaster",
    "name": "Supplier Master",
    "entity": "User",
    "designation": "supplier",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      },
      {
        "id": "masterDownload",
        "icon": "masterDownloadIcon",
        "label": "Master Download"
      }
    ],
    "transformerInfo": [{
      "entityName": "SupplierMaster",
      "transformerId": "default_suppliermaster"
  }]
  },
  {
    "id": "OutletDetails",
    "name": "Outlet Details",
    "entity": "OutletDetails",
    "designation": "",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      },
      {
        "id": "viewsAndEdit",
        "icon": "viewsAndEditIcon",
        "label": "View and Edit"
      },
      {
        "id": "masterDownload",
        "icon": "masterDownloadIcon",
        "label": "Master Download"
      },
      {
        "id": "dataSupportDownload",
        "icon": "masterDownloadIcon",
        "label": "Data Validation Support"
      }
    ],
    "transformerInfo": [{
      "entityName": "User",
      "transformerId": "mdm_outletdetails_user",
      "operationType": "merge"//
    },
    {
        "entityName": "OutletDetails",
        "transformerId": "mdm_outletdetails"
    },
    ]
  },
  {
    "id": "ProductDetails",
    "name": "Product Details",
    "entity": "ProductDetails",
    "designation": "",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      },
      {
        "id": "viewsAndEdit",
        "icon": "viewsAndEditIcon",
        "label": "View and Edit"
      },
      {
        "id": "masterDownload",
        "icon": "masterDownloadIcon",
        "label": "Master Download"
      },
      {
        "id": "dataSupportDownload",
        "icon": "masterDownloadIcon",
        "label": "Data Validation Support"
      }
    ],
    "transformerInfo": [{
      "entityName": "ProductDetails",
      "transformerId": "mdm_productdetails"
  },
  {
      "entityName": "ProductMetaData",
      "transformerId": "mdm_productmetadata"
  },
  ]
  },

  {
    "id": "ProductDetailsV4",
    "name": "Product Details",
    "entity": "ProductDetails",
    "designation": "",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "viewsAndEdit",
        "icon": "viewsAndEditIcon",
        "label": "Views and Edit"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "ProductDetails",
      "transformerId": "bepensa_rec_block"
    }]
  },
  {
    "id": "Targets",
    "name": "Targets",
    "entity": "Targets",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      },
      {
        "id": "dataSupportDownload",
        "icon": "masterDownloadIcon",
        "label": "Data Validation Support"
      }
    ],
    "transformerInfo": [{
      "entityName": "Targets",
      "transformerId": "default_targets"
  }]
  },
  {
    "id": "PJPVisitPlan",
    
    "name": "PJP Visit Plan",
    "entity": "DeliveryPJP",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      },
      {
        "id": "masterDownload",
        "icon": "masterDownloadIcon",
        "label": "Master Download"
      },
      {
        "id": "dataSupportDownload",
        "icon": "masterDownloadIcon",
        "label": "Data Validation Support"
      }
    ],
    "transformerInfo": [{
      "entityName": "DeliveryPJP",
      "transformerId": "default_deliverypjp"
  }]
  },
  {
    "id": "SecondaryProduct",
    "name": "Secondary Product",
    "entity": "SecondaryProduct",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "SecondaryProduct",
      "transformerId": "default_secondaryproduct"
  }]
  },
  {
    "id": "SalesTargetMaster",
    "name": "Sales Target Master",
    "entity": "SalesTargetMaster",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "SalesTargetMaster",
      "transformerId": "default_SalesTargetMaster"
  }]
  },
  {
    "id": "ProductMetaData",
    "name": "Price Master",
    "entity":"ProductMetaData",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "ProductMetaData",
      "transformerId": "mdm_productmetadata"
  }]
  },
  {
    "id": "SchemesMaster",
    "name": "Schemes Master",
    "entity":"SchemeDefination",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "SchemeDefination",
      "transformerId": "genericSchemeTransformer"
  }]
  },
  {
    "id": "ProductImage",
    "name": "Product Image",
    "entity":"ProductDetails",
    "fileType": "zip",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "ProductDetails",
      "transformerId": "default_productdetails"
  }]
  },
  {
    "id": "Device Info",
    "name": "Device Info",
    "entity": "Device Info",
    "menuOption": [
      {
        "id": "dataSupportDownload",
        "icon": "masterDownloadIcon",
        "label": "Data Validation Support"
      }
    ],
    "transformerInfo": [{
      "entityName": "Device Info",
      "transformerId": "default_device info"
  }]
  },
  {
    "id": "faq",
    "name": "FAQs",
    "entity": "SellinaAIQuery",
    "transformerId": "default_faq1",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "SellinaAIQuery",
          "transformerId": "default_faq1"
      }
  ]
  },
  {
    "id": "genericEntity",
    "name": "Hierarchy Code Master",
    "entity": "GenericEntity",
    "transformerId": "EnrichHierarchyCodeMaster",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "GenericEntity",
      "transformerId": "default_genericentity"
  }]
  },
  {
    "id": "stock",
    "name": "Stock",
    "entity": "Stock",
    "transformerId": "StockTransformationMinQty",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "Stock",
      "transformerId": "StockTransformationMinQty"
  }]
  },
  {
    "id": "SchemeDefination",
    "name": "SchemeDefination",
    "entity": "SchemeDefination",
    "transformerId": "ilc_transformer",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "SchemeDefination",
          "transformerId": "ilc_transformer"
      }
  ]
  },
  {
    "id": "ProductDetailsV2",
    "name": "Product Details",
    "entity": "ProductDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "ProductDetails",
      "transformerId": "mdm_productdetails"
    },
    {
        "entityName": "ProductMetaData",
        "transformerId": "mdm_productmetadata"
    },
    ]
  },
  {
    "id": "ProductName",
    "name": "Product Name",
    "entity": "ProductDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "ProductDetails",
      "transformerId": "mdm_productdetails_name"
    }
    ]
  },{
    "id": "SchemeDefinationV2",
    "name": "SchemeDefination",
    "entity": "SchemeDefination",
    "transformerId": "ilc_transformer",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "SchemeDefination",
          "transformerId": "ilc_transformer"
      },
      {
        "entityName": "SchemeMustBuyGroup",
        "transformerId": "mustBuyGroupIlcTransformer"
      }
  ]
  },
  {
    "id": "wdViewAndEdit",
    "name": "WD View And Edit",
    "entity": "User",
    "designation":"supplier",
    "menuOption": [
      {
        "id": "viewsAndEdit",
        "icon": "viewsAndEditIcon",
        "label": "Views and Edit"
      },
    ],
    "transformerInfo": [{
      "entityName": "User",
      "transformerId": "mdm_user"
    }]
  },
    {
        "id": "DeleteEnrollment",
        "entity": "GenericEntity",
        "name": "DeleteEnrollment",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "GenericEntity",
                "operationType": "delete",
                "transformerId": "mdm_Generic_Object_Delete"
            },
        ]
    },
    {
      "id": "LeadTimeMapping",
      "name": "Lead Time Mapping",
      "entity": "GenericEntity",
      "transformerId": "RegionWiseLeadTimeTransformer",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [{
        "entityName": "GenericEntity",
        "transformerId": "RegionWiseLeadTimeTransformer"
    }]
    },
    {
      "id": "ProductManagement",
      "name": "Product Management",
      "entity": "ProductDetails",
      "transformerId": "mdm_product_details_transformer",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [{
        "entityName": "ProductDetails",
        "transformerId": "mdm_product_details_transformer"
    }]
    },
    {
        "id": "BankNames",
        "entity": "GenericEntity",
        "name": "BankNames",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "GenericEntity",
                "transformerId": "finance_bank_names_transformer",
                "skipPreprocessing": true
            }
        ]
    },
    {
        "id": "OutletDeactivation",
        "entity": "OutletDetails",
        "name": "OutletDeactivation",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "OutletDetails",
                "transformerId": "mdm_outletdetails_1"
            }
        ]
    },
    {
        "id": "WDPortalAccess",
        "entity": "User",
        "name": "WDPortalAccess",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "User",
                "transformerId": "loginAccess"
            }
        ]
    },
    {
        "id": "FinaggAgreementUpload",
        "entity": "PaymentSubscription",
        "name": "FinaggAgreementUpload",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "PaymentSubscription",
                "transformerId": "paymentsubscriptoin"
            }
        ]
    },
    {
        "id": "ExistingRetailerOnboarding",
        "entity": "CreditStatus",
        "name": "ExistingRetailerOnboarding",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "CreditStatus",
                "transformerId": "mdm_old_retailer_migration_credit_status"
            },
            {
                "entityName": "PaymentSubscription",
                "transformerId": "mdm_old_retailer_migration_payment_subscription"
            },
            {
                "entityName": "OutletDetails",
                "transformerId": "mdm_outletdetails_odstatus_paymentsubscription_updater"
            }
        ]
    },
    {
        "id": "User-Mobile-Update",
        "entity": "User",
        "name": "User-Mobile-Update",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "User",
                "transformerId": "mdm_mobile_user"
            }
        ]
    },
    {
        "id": "ProductDetailsImage",
        "entity": "ProductDetails",
        "name": "ProductDetailsImage",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "ProductDetails",
                "transformerId": "mdm_product_details_image_master"
            }
        ]
    },
    {
        "id": "ProductDetailsV3",
        "entity": "ProductDetails",
        "name": "ProductDetailsV3",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "ProductDetails",
                "transformerId": "mdm_product_details"
            }
        ]
    },
    {
        "id": "ScoreDetails",
        "entity": "ScoreDetails",
        "name": "ScoreDetails",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "ScoreDetails",
                "transformerId": "mdm_scoredetails"
            }
        ]
    },
    {
        "id": "visibilityScoreDetails",
        "entity": "ScoreDetails",
        "name": "visibilityScoreDetails",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "ScoreDetails",
                "transformerId": "store_visibility_to_score"
            }
        ]
    },
    {
        "id": "RedeemActivity",
        "entity": "RedeemActivity",
        "name": "RedeemActivity",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "RedeemActivity",
                "transformerId": "unnati_redeem_activity"
            }
        ]
    },
    {
        "id": "Invoice",
        "entity": "Invoice",
        "name": "Invoice",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "Sales",
                "transformerId": "default_sales"
            }
        ]
    },
    {
        "id": "DEVICE-INFO-UPDATE",
        "entity": "DeviceInfo",
        "name": "DEVICE-INFO-UPDATE",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "DeviceInfo",
                "transformerId": "DeviceIdUpdate"
            }
        ]
    },
    {
        "id": "VisibleScheme",
        "entity": "GenericEntity",
        "name": "VisibleScheme",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "GenericEntity",
                "transformerId": "mdm_Generic_Object_Scheme",
                "preprocessValidationExcludeGroup": "scheme_validation_exclude"
            }
        ]
    },
    {
        "id": "Enrollment",
        "entity": "GenericEntity",
        "name": "Enrollment",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "GenericEntity",
                "transformerId": "mdm_Generic_Object"
            }
        ]
    },
    {
        "id": "AnalyticMappingUpload",
        "entity": "GenericEntity",
        "name": "AnalyticMappingUpload",
        "menuOption": [
          {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
          },
          {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
          }
        ],
        "transformerInfo": [
            {
                "entityName": "GenericEntity",
                "transformerId": "mdm_analytic_mapping_upload",
                "skipPreprocessing": true
            }
        ]
    },
    {
      "id": "PaymentAccess",
      "entity": "PaymentSubscription",
      "name": "PaymentAccess",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "PaymentSubscription",
          "transformerId": "mdm_retailer_permission_update"
        }
      ]
    },
    {
      "id": "OnboadingAccess",
      "entity": "PaymentSubscription",
      "name": "OnboadingAccess",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "PaymentSubscription",
          "transformerId": "mdm_retailer_permission_update"
        }
      ]
    },
    {
      "id": "ExistingRetailerOnboardingV2",
      "name": "ExistingRetailerOnboarding",
      "entity": "CreditStatus",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "CreditStatus",
          "transformerId": "mdm_old_retailer_migration_credit_status"
        },
        {
          "entityName": "PaymentSubscription",
          "transformerId": "mdm_old_retailer_migration_payment_subscription"
        }
      ]
    },
    // {
    //   "id": "BrandCodeTransformer",
    //   "name": "Short Brand Code",
    //   "entity": "ProductDetails",
    //   "menuOption": [
    //     {
    //       "id": "import",
    //       "icon": "importIcon",
    //       "label": "Import"
    //     },
    //     {
    //       "id": "logsAndReport",
    //       "icon": "logsAndReportIcon",
    //       "label": "Logs and Reports"
    //     }
    //   ],
    //   "transformerInfo": [
    //     {
    //       "entityName": "ProductDetails",
    //       "transformerId": "BrandCodeTransformer"
    //     }
    //   ]
    // },
    {
      "id": "BrandCodeTransformer",
      "name": "Short Brand Code",
      "entity": "ProductDetails",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "ProductDetails",
          "transformerId": "BrandCodeTransformer"
        }
      ]
    },
    {
      "id": "PJPVisitPlanV2",
      "name": "DeliveryPJP",
      "entity": "DeliveryPJP",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "DeliveryPJP",
          "transformerId": "default_deliverypjp"
        }
      ]
    },
    {
      "id": "outletMappingLocation",
      "name": "New Outlet Mapping Location",
      "entity": "Location",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "Location",
          "transformerId": "default_location"
        }
      ]
    },
    {
      "id": "outletMappingChannel",
      "name": "New Outlet Mapping Channel",
      "entity": "GenericEntity",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "GenericEntity",
          "transformerId": "mdm_outlet_mapping_channel"
        }
      ]
    },
    {
      "id": "UidOndcMapping",
      "entity": "OutletDetails",
      "name": "UID ONDC Mapping",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "OutletDetails",
          "transformerId": "Uid_OndcProviderMappingTransformer"
        }
      ]
    },
    {
      "id": "coolerSurvey",
      "entity": "Asset",
      "name": "Cooler Survey",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "Asset",
          "transformerId": "assetTransformer"
        }
      ]
    },
    {
      "id": "UPIPaymentPermission",
      "entity": "PaymentSubscription",
      "name": "UPI Payment Permission",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
          {
              "entityName": "PaymentSubscription",
              "transformerId": "unnati_payment_subscription"
          }
      ]
  },
  {
    "id": "Region_State_Map",
    "name": "Region_State_Map",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "GenericEntity",
      "transformerId": "SimaRegionStateMapper"
  }]
  },
  {
    "id": "generalPromotions",
    "name": "General Promotions",
    "entity": "SchemeDefination",
    "transformerId": "genericSchemeTransformer",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "SchemeDefination",
          "transformerId": "genericSchemeTransformer"
      }
    ]
  },
  {
    "id": "productTag",
    "name": "Product Tag",
    "entity": "ProductTag",
    "transformerId": "Bepensa_producttag_transformer",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "ProductTag",
          "transformerId": "Bepensa_producttag_transformer"
      }
    ]
  },
  {
    "id": "SchemeRegionMapping",
    "name": "Scheme-Region-Mapping",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "GenericEntity",
      "transformerId": "SchemeRegionGeSimaTransformer"
  }]
  },
  // {
  //   "id": "generalPromotions",
  //   "name": "General Promotions",
  //   "entity": "SchemeDefination",
  //   "transformerId": "genericSchemeTransformer",
  //   "menuOption": [
  //     {
  //       "id": "import",
  //       "icon": "importIcon",
  //       "label": "Import"
  //     },
  //     {
  //       "id": "logsAndReport",
  //       "icon": "logsAndReportIcon",
  //       "label": "Logs and Reports"
  //     }
  //   ],
  //   "transformerInfo": [
  //     {
  //         "entityName": "SchemeDefination",
  //         "transformerId": "genericSchemeTransformer"
  //     }
  //   ]
  // },
  // {
  //   "id": "productTag",
  //   "name": "Product Tag",
  //   "entity": "ProductTag",
  //   "transformerId": "Bepensa_producttag_transformer",
  //   "menuOption": [
  //     {
  //       "id": "import",
  //       "icon": "importIcon",
  //       "label": "Import"
  //     },
  //     {
  //       "id": "logsAndReport",
  //       "icon": "logsAndReportIcon",
  //       "label": "Logs and Reports"
  //     }
  //   ],
  //   "transformerInfo": [
  //     {
  //         "entityName": "ProductTag",
  //         "transformerId": "Bepensa_producttag_transformer"
  //     }
  //   ]
  // },
    {
      "id": "recoKey",
      "name": "Reco Key",
      "entity": "ProductDetails",
      "designation": "",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [{
        "entityName": "ProductDetails",
        "transformerId": "bepensa_rec_block"
      }
      ]
    },
  {
    "id": "userMaster",
    "name": "Salesrep User Master",
    "entity": "User",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "User",
        "transformerId": "dms_mdm_generic_user_master_data_transformer"
      }
    ]
  },
  {
    "id": "outletMaster",
    "name": "Outlet Master",
    "entity": "OutletDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "User",
          "transformerId": "dms_mdm_outlet_master_user"
        },
        {
          "entityName": "OutletDetails",
          "transformerId": "dms_outlet_master_data_transformer"
        },
        {
          "entityName": "AccountInfo",
          "transformerId": "dms_mdm_outlet_account_info"
        },
        {
          "entityName": "CreditStatus",
          "transformerId": "dms_outlet_credit_status_transformer"
        }
      ]
  },
  {
    "id": "companyMaster",
    "name": "Company Master",
    "entity": "User",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "User",
          "transformerId": "dms_mdm_company_user"
        },
        {
          "entityName": "AccountInfo",
          "transformerId": "dms_mdm_company_account_info_transformer"
        }
      ]
  },
  {
    "id": "distributerMaster",
    "name": "Distributer Master",
    "entity": "User",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "User",
          "transformerId": "dms_mdm_distributer_user_transformer"
        },
        {
          "entityName": "OutletDetails",
          "transformerId": "dms_mdm_distributer_outlet_transformer"
        },
        {
          "entityName": "AccountInfo",
          "transformerId": "dms_mdm_distributer_account_info_transformer"
        }
      ]
  },
  {
    "id": "deliveryPJPMaster",
    "name": "Delivery PJP Master",
    "entity": "DeliveryPJP",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "User",
          "transformerId": "dms_mdm_salesrep_user_transformer"
        },
        {
          "entityName": "DeliveryPJP",
          "transformerId": "dms_mdm_deliverypjp_transformer"
        }
      ]
  },
  {
    "id": "secondaryProductMaster",
    "name": "Secondary Product Master",
    "entity": "SecondaryProduct",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "SecondaryProduct",
          "transformerId": "dms_mdm_secondryProductTransformer"
        }
      ]
  },
  {
    "id": "productMaster",
    "name": "Product Master",
    "entity": "ProductDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "ProductDetails",
          "transformerId": "dms_mdm_product_details"
        },
        {
          "entityName": "ProductMetaData",
          "transformerId": "dms_mdm_product_metadata"
        }
      ]
  },
  {
    "id": "vehicleMaster",
    "name": "Vehicle Master",
    "entity": "VehicleInfo",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "GenericEntity",
          "transformerId": "dms_vehicle_master_transformer"
        }
      ]
  },
  {
    "id": "staffMaster",
    "name": "Staff Master",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "GenericEntity",
          "transformerId": "dms_staff_master_transformer"
        }
      ]
  },
  {
    "id": "primaryPriceMaster",
    "name": "Primary Price Master",
    "entity": "ProductMetaData",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "ProductMetaData",
          "transformerId": "dms_primary_price_productmetadata_transformer"
        }
      ]
  },
  {
    "id": "secondaryPriceMaster",
    "name": "Secondary Price Master",
    "entity": "ProductMetaData",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo":
      [
        {
          "entityName": "ProductMetaData",
          "transformerId": "dms_secondary_price_productmetadata_transformer"
        }
      ]
  },
  {
    "id": "brandProductMaster",
    "name": "Brand Product Master",
    "entity": "ProductDetails",
    "menuOption": [
      {
        "id": "viewsAndEdit",
        "icon": "viewsAndEditIcon",
        "label": "Views and Edit"
      },
    ],
    "transformerInfo": [{
      "entityName": "ProductDetails",
      "transformerId": "mdm_productdetails"
    }]
  },
  {
    "id": "taxMaster",
    "name": "Tax",
    "entity": "Tax",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "Tax",
          "transformerId": "tax"
      }
  ]
  },
   {
    "id": "OrderPurchaseConstraints",
    "name": "OrderPurchaseConstraints",
    "entity": "OrderPurchaseConstraints",
    "designation": "",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "OrderPurchaseConstraints",
      "transformerId": "OrderPurchaseConstraintTransformer_swire"
    }
    ]
  },
  {
    "id": "stockNew",
    "name": "Stock Upload",
    "entity": "Stock",
    "designation": "",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [{
      "entityName": "Stock",
      "transformerId": "stock_micro_service",
      "operationType": "insert",
    }
    ]
  },
  {
    "id": "Scheme Defination COE",
    "name": "Scheme Defination COE",
    "entity": "SchemeDefination",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "SchemeDefination",
          "transformerId": "SchemeDMS"
      }
  ]
  },
  {
    "id": "Scheme Defination Itemwise",
    "name": "Scheme Defination Itemwise",
    "entity": "SchemeDefination",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "SchemeDefination",
          "transformerId": "SchemesCfDMS"
      }
  ]
  },
  {
    "id": "TRO-Outlet Exclusion",
    "name": "TRO-Outlet Exclusion [BonPC]",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "GenericEntity",
          "transformerId": "SimaOutletExclusionPromo"
      }
  ]
  },
  {
    "id": "ProductBarcode",
    "name": "ProductBarcode",
    "entity": "ProductBarcode",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "ProductBarcode",
          "transformerId": "ConsumerPromoTransformer"
      }
    ]
  },
  {
    "id": "scheme-promo",
    "name": "Promotions",
    "entity": "promoentity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "definition",
        "transformerId": "NiinePromosTransformer",
        "operationType": "merge"
      },
      {
          "entityName": "parallelfilters",
          "transformerId": "NiinePromosTransformer",
          "operationType": "merge"
      },
      {
          "entityName": "verticalfilters",
          "transformerId": "NiinePromosTransformer",
          "operationType": "merge"
      }
    ],
    "useKafka": true
  },
  {
    "id": "Salesman User Transformer",
    "name": "Salesman User Transformer",
    "entity": "User",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "User",
          "transformerId": "dms_mdm_salesman_user_transformer"
      }
    ]
  },
  {
    "id": "TRO-Outlet Inclusion",
    "name": "TRO-Outlet Inclusion [BonPC]",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "GenericEntity",
          "transformerId": "SimaInclusionTransformer"
      }
  ]
  },
  {
    "id": "Route Info Transformer",
    "name": "Route Info Transformer",
    "entity": "RouteInfo",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "RouteInfo",
          "transformerId": "kevin_route_info_transformer"
      }
  ]
  },
  {
    "id": "Cavincare_dms_routetofrequency_transformer",
    "name": "Cavincare_dms_routetofrequency_transformer",
    "entity": "TempDeliveryPJP",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "TempDeliveryPJP",
          "transformerId": "Cavincare_dms_routetofrequency_transformer"
      }
  ]
  },
  {
    "id": "Cavincare_dms_routetooutlet_transformer",
    "name": "Cavincare_dms_routetooutlet_transformer",
    "entity": "EntityMapping",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "EntityMapping",
          "transformerId": "Cavincare_dms_routetooutlet_transformer"
      }
  ]
  },
  {
    "id": "Cavincare_SKU_GroupCreation_transformer",
    "name": "Cavincare_SKU_GroupCreation_transformer",
    "entity": "EntityMapping",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "EntityMapping",
          "transformerId": "Cavincare_SKU_GroupCreation_transformer",
          "skipPreprocessing": true
      }
  ]
  },
  {
    "id": "OutletCategory",
    "name": "OutletCategory",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "GenericEntity",
          "transformerId": "outlet_category"
      }
  ]
  },
  {
    "id": "moq_template",
    "name": "moq_template",
    "entity": "OrderPurchaseConstraints",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "OrderPurchaseConstraints",
          "transformerId": "OrderPurchaseConstraintTransformer_ckcoe"
      }
  ]
  },
  {
    "id": "ProductReplacement",
    "name": "ProductReplacement",
    "entity": "EntityMapping",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "EntityMapping",
          "transformerId": "ProductReplacement"
      }
  ]
  },
  {
    "id": "Cavincare_SKULine_Mapping_transformer",
    "name": "SKU Line Mapping",
    "entity": "TempMasterMapping",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "TempMasterMapping",
        "transformerId": "Cavincare_SKULine_Mapping_transformer"
      }
    ]
  },
{
    "id": "eb2b_stock",
    "name": "Stock New",
    "entity": "Stock",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "Stock",
        "transformerId": "eb2b_stock"
      }
    ]
  },
  {
    "id": "CatalogueSequencing",
    "name": "Catalogue Sequencing",
    "entity": "ProductTag",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "ProductTag",
        "transformerId": "CatalogueSequencingTransformer"
      }
    ]
  },
   {
    "id": "CatalogueSequencing2",
    "name": "Catalogue Sequencing2",
    "entity": "ProductTag",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "ProductTag",
        "transformerId": "CatalogueSequencingTransformer"
      }
    ]
  },
  {
    "id": "simamy_Exclusion",
    "name": "Product Exclusion",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "GenericEntity",
        "transformerId": "ProductExclusionSIMA"
      }
    ]
  },
  {
    "id": "mdm_targets",
    "name": "Sales Target",
    "entity": "Targets",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "Targets",
        "transformerId": "mdm_targets"
      }
    ]
  },
  {
    "id": "RouteCreation",
    "name": "Route Info",
    "entity": "EntityMapping",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "EntityMapping",
        "transformerId": "RouteCreation"
      }
    ]
  },
  {
    "id": "Cavincare_UserMDM_transformer",
    "name": "User MDM",
    "entity": "User",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "User",
        "transformerId": "Cavincare_UserMDM_transformer"
      }
    ]
  },
  {
    "id": "CavinKare_SalesHierarchy_Creation",
    "name": "Sales Hierarchy Creation",
    "entity": "EntityParentMapping",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "EntityParentMapping",
        "transformerId": "CavinKare_SalesHierarchy_Creation"
      }
    ]
  },
  {
    "id": "secondaryProductMaster2",
    "name": "Focus Product",
    "entity": "SecondaryProduct",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "SecondaryProduct",
        "transformerId": "focus_secondaryproduct"
      }
    ]
  },
  {
    "id": "MOV for CLO",
    "name": "MOV for CLO",
    "entity": "OrderPurchaseConstraints",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "OrderPurchaseConstraints",
        "transformerId": "mdm_order_purchase_constraints_transformer"
      }
    ]
  },
  {
    "id": "SalesReturn_Restriction",
    "name": "Sales Return Restriction",
    "entity": "EntityMapping",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "EntityMapping",
        "transformerId": "Cavincare_SalesReturn_Restriction_SFA"
      }
    ]
  },
  {
    "id": "EntityParentMapping",
    "name": "Distributor TGO Mapping",
    "entity": "EntityParentMapping",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "EntityParentMapping",
        "transformerId": "CavinKare_DistributorTGO_mapping"
      }
    ]
  },
  {
    "id": "DeliveryPJP",
    "name": "DeliveryPJP",
    "entity": "DeliveryPJP",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "DeliveryPJP",
        "transformerId": "DeliveryPJPCokeNP"
      }
    ]
  },
  {
    "id": "Stock",
    "name": "Stock",
    "entity": "Stock",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "Stock",
        "transformerId": "StockTransformerCokeNP"
      }
    ]
  },
  {
    "id": "CokePhWholesalerTransformer",
    "name": "CokePhWholesalerTransformer",
    "entity": "OutletDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "OutletDetails",
        "transformerId": "CokePhWholesalerTransformer"
      }
    ]
  },
  {
    "id": "manualStockAdjustment",
    "name": "Bulk Manual Stock Adjustment",
    "entity": "Stock",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "Stock",
        "transformerId": "Manual_Bulk_Stock_Adjustment_Micro_Service"
      }
    ]
  },
  {
    "id": "stockTypeUpdate",
    "name": "Stock Type Update",
    "entity": "Stock",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "Stock",
        "transformerId": "Stock_Type_Update_Micro_Service"
      }
    ]
  }
,
  {
    "id": "RouteSalesmanMigrationTransformer",
    "name": "Route Salesman Migration",
    "entity": "RouteInfo",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "RouteInfo",
        "transformerId": "RouteSalesmanMigrationTransformer"
      }
    ]
  },
  {
    "id": "fullMigration",
    "name": "Full Migration",
    "entity": "UserParent",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "UserParent",
        "transformerId": "userParentIntegration"
      }
    ]
  },
  {
    "id": "partialMigration",
    "name": "Partial Migration",
    "entity": "UserParent",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "UserParent",
        "transformerId": "userParentIntegration"
      }
    ]
  },
  {
    "id": "salesmanSharingMigration",
    "name": "Salesman Sharing",
    "entity": "UserParent",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "UserParent",
        "transformerId": "userParentIntegration"
      }
    ]
  },
  {
    "id": "OutletBeatMigrationTransformer",
    "name": "Outlet Beat Migration",
    "entity": "OutletDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "OutletDetails",
        "transformerId": "OutletBeatMigrationTransformer"
      }
    ]
  },
  {
    "id": "SiteWareHouseMapping",
    "name": "SiteWareHouseMapping",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "GenericEntity",
        "transformerId": "DefaultSiteWarehouseTransformer"
      }
    ]
  },
  {
    "id": "Location",
    "name": "Location",
    "entity": "OutletDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "OutletDetails",
        "transformerId": "OutletDetailsUpdateTransformer"
      }
    ]
  },
  {
    "id": "distributorServingRadius",
    "name": "Distributor Serving Radius",
    "entity": "OutletDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "OutletDetails",
        "transformerId": "CokePhGeoDistributorTransfomer"
      }
    ]
  },
    {
    "id": "Distributor VSO Mapping",
    "name": "Distributor VSO Mapping",
    "entity": "UserParent",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "UserParent",
        "transformerId": "CavinKare_DistributorVSO_mapping"
      }
    ]
  },
  {
    "id": "Claims User ETL",
    "name": "Claims User ETL",
    "entity": "User",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "User",
        "transformerId": "Cavincare_Claims_User_transformer",
        "operationType": "insert"
      }
    ]
  },
  {
    "id": "ProductHierarchy",
    "name": "Product Hierarchy",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "GenericEntity",
        "transformerId": "Cavincare_ProductHierarchy_transformer_ETL",
      }
    ]
  },
   {
    "id": "MaxOrderPurchaseConstraint",
    "name": "MaxOrderCapping",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "OrderPurchaseConstraints",
        "transformerId": "OrderPurchaseConstraintTransformer",
      }
    ]
  },{
    "id": "Asset",
    "name": "Asset",
    "entity": "Asset",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "Asset",
        "transformerId": "AssetTransformerCokeSA",
      }
    ]
  },
  {
    "id": "supplier-route-geofencing",
    "name": "Supplier Route GeoFencing",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "GenericEntity",
          "transformerId": "supplier_route_geofencing_transformer"
      }
  ]
  },
  {
    "id": "ASM Geo-Fencing",
    "name": "ASM Geo-Fencing",
    "entity": "GenericEntity",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "GenericEntity",
          "transformerId": "AsmGeoFencingTransformer"
      }
  ]
  },
  {
    "id": "NonCokeProductDetails",
    "name": "NonCokeProductDetails",
    "entity": "ProductDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "ProductDetails",
          "transformerId": "OutletwiseProductDetailsTransformer"
      }, 
      {
          "entityName": "ProductMetadata",
          "transformerId": "OutletwiseProductMetadataTransformer"
      }
  ]
  },
  {
    "id": "PrimarySales",
    "name": "Primary Sales",
    "entity": "Sales",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "skipPersist": "true",
           "entityName": "Sales",
          "transformerId": "MDMPrimarySalesTransformer"
      }
  ]
  },
  {
    "id": "SchemeDefinationid",
    "name": "Bundle Coupon",
    "entity": "SchemeDefination",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
          "entityName": "SchemeDefination",
          "transformerId": "BundleCouponTransformer"
      }
  ]
  },
    {
      "id": "TargetVsAch",
      "name": "Target Vs Ach",
      "entity": "Targets",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "Targets",
          "transformerId": "GCPLTargetDetailsTransformer"
        }
      ]
    },
    {
      "id": "PaymentCollection",
      "name": "Payment Collection",
      "entity": "PaymentCollection",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "PaymentCollection",
          "transformerId": "GCPLPaymentCollectionTransformer"
        }
      ]
    },
    {
      "id": "RFC-User",
      "name": "RFC-User",
      "entity": "User",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "User",
          "transformerId": "MDMRfcUserTransformerCokeSA"
        }
      ]
    },
    {
      "id": "QPS_Achievement",
      "name": "QPS Achievement",
      "entity": "GenericEntity",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "GenericEntity",
          "transformerId": "QPS_Achievement_Transformer"
        }
      ]
    },
    {
      "id": "Supervisor",
      "name": "Supervisor",
      "entity": "User",
      "menuOption": [
        {
          "id": "import",
          "icon": "importIcon",
          "label": "Import"
        },
        {
          "id": "logsAndReport",
          "icon": "logsAndReportIcon",
          "label": "Logs and Reports"
        }
      ],
      "transformerInfo": [
        {
          "entityName": "User",
          "transformerId": "MdmSupplierTransformerCokeSA"
        }
      ]
    },
    {
    "id": "ProductDisplayTransformer",
    "name": "Wholesaler Stocks",
    "entity": "ProductDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "ProductDetails",
        "transformerId": "ProductDisplayTransformer"
      }
    ]
  },
    {
    "id": "DistributorEPODenabling",
    "name": "Distributor EPOD enabling",
    "entity": "User",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "User",
        "transformerId": "DistributorEpod",
        "operationType": "insert",
      }
    ]
  },
  {
    "id": "RcMappingTransformer",
    "name": "RC Mapping",
    "entity": "ProductDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "ProductDetails",
        "transformerId": "RcMappingTransformer"
      }
    ]
  },
  {
  "id": "RecommendedOrderMDM",
  "name": "Recommended Order",
  "entity": "RecommendedOrder",
  "menuOption": [
    {
      "id": "import",
      "icon": "importIcon",
      "label": "Import"
    },
    {
      "id": "logsAndReport",
      "icon": "logsAndReportIcon",
      "label": "Logs and Reports"
    }
  ],
  "transformerInfo": [
    {
      "entityName": "RecommendedOrder",
      "transformerId": "mdm_recommendation_master_transformer",
      "operationType": "insert"
    }
  ]
},
{
  "id": "MappedDataMDM",
  "name": "Mapped Data",
  "entity": "OutletLevelRecommendation",
  "menuOption": [
    {
      "id": "import",
      "icon": "importIcon",
      "label": "Import"
    },
    {
      "id": "logsAndReport",
      "icon": "logsAndReportIcon",
      "label": "Logs and Reports"
    }
  ],
  "transformerInfo": [
    {
      "entityName": "OutletLevelRecommendation",
      "transformerId": "mdm_mapped_data_master_transformer",
      "operationType": "insert"
    }
  ]
},
{
  "id": "TargetAchievementMDM",
  "name": "Target and Achievement",
  "entity": "Targets",
  "menuOption": [
    {
      "id": "import",
      "icon": "importIcon",
      "label": "Import"
    },
    {
      "id": "logsAndReport",
      "icon": "logsAndReportIcon",
      "label": "Logs and Reports"
    }
  ],
  "transformerInfo": [
    {
      "entityName": "Targets",
      "transformerId": "mdm_target_achievement_mdm_transformer",
      "operationType": "insert"
    }
  ]
},
{
  "id": "LoyaltyScore",
  "name": "Loyalty Score",
  "entity": "ScoreDetails",
  "menuOption": [
    {
      "id": "import",
      "icon": "importIcon",
      "label": "Import"
    },
    {
      "id": "logsAndReport",
      "icon": "logsAndReportIcon",
      "label": "Logs and Reports"
    }
  ],
  "transformerInfo": [
    {
      "entityName": "ScoreDetails",
      "transformerId": "mdm_loyalty_score_mdm_transformer",
      "operationType": "insert"
    }
  ]
},
{
    "id": "OutletDetails_1",
    "name": "Outlet Details New",
    "entity": "OutletDetails",
    "menuOption": [
      {
        "id": "import",
        "icon": "importIcon",
        "label": "Import"
      },
      {
        "id": "logsAndReport",
        "icon": "logsAndReportIcon",
        "label": "Logs and Reports"
      }
    ],
    "transformerInfo": [
      {
        "entityName": "OutletDetails",
        "transformerId": "mdm_outlet_inactive_validation",
      }
    ]
  }
]

export const defaultMenuOptions = [
  {
    "id": "import",
    "icon": "importIcon",
    "label": "Import"
  },
  {
    "id": "logsAndReport",
    "icon": "logsAndReportIcon",
    "label": "Logs and Reports"
  }
];

export const MENU_OPTIONS_MAP: Record<string, { label: string; icon: string }> = {
  import: { label: "Import", icon: "importIcon" },
  logsAndReport: { label: "Logs and Reports", icon: "logsAndReportIcon" },
  viewsAndEdit: { label: "View and Edit", icon: "viewsAndEditIcon" },
  masterDownload: { label: "Master Download", icon: "masterDownloadIcon" },
  dataSupportDownload: { label: "Data Validation Support", icon: "masterDownloadIcon" },
};